import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TSelectOption } from 'src/app/project/components/input/select/select.model';
import { EAdvancedFilterOptions } from '../../../../models/advanced-filter-options.enum';
import {
  TAdvancedFilterReminderState,
  TAdvancedFilterSingle,
  TFilterReminderStateOptions,
} from '../../../../models/advanced-filter.model';
import { getAdvancedReminderStateOptions } from './get-advanced-filter-reminder-state-options';

@Component({
    selector: 'pp-advanced-filter-reminder-state',
    templateUrl: './advanced-filter-reminder-state.component.html',
    styleUrl: './advanced-filter-reminder-state.component.scss',
    standalone: false
})
export class AdvancedFilterReminderStateComponent {
  @Input() ppFilter: TAdvancedFilterSingle;
  @Output() ppFilterChange = new EventEmitter<TAdvancedFilterSingle>();

  option: TFilterReminderStateOptions;
  filter: TAdvancedFilterReminderState;

  advancedFilterReminderStateOptions = getAdvancedReminderStateOptions();
  EAdvancedFilterOptions = EAdvancedFilterOptions;

  ngOnChanges(): void {
    this.filter = this.ppFilter as TAdvancedFilterReminderState;

    this.option = this.filter.option;
  }

  changeFieldCondition(newCondition: TSelectOption): void {
    this.ppFilter.option = newCondition.value as TFilterReminderStateOptions;
    this.option = newCondition.value as TFilterReminderStateOptions;
    this.applyChanges();
  }

  applyChanges(): void {
    this.ppFilterChange.emit(this.ppFilter);
  }
}
